/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardCctDto
 */
export interface DashboardCctDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardCctDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctDto
     */
    idcontrat?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctDto
     */
    statutContrat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctDto
     */
    concerne?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DashboardCctDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctDto
     */
    codeContrat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctDto
     */
    metiers?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctDto
     */
    nbJoursAre?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctDto
     */
    idari?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctDto
     */
    idpri?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctDto
     */
    pri?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DashboardCctDto
     */
    dateDernierCct?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DashboardCctDto
     */
    dateDernierCctScreening?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctDto
     */
    centresA?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctDto
     */
    centresBI?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctDto
     */
    idservice?: number | null;
}

/**
 * Check if a given object implements the DashboardCctDto interface.
 */
export function instanceOfDashboardCctDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardCctDtoFromJSON(json: any): DashboardCctDto {
    return DashboardCctDtoFromJSONTyped(json, false);
}

export function DashboardCctDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCctDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'idcontrat': !exists(json, 'idcontrat') ? undefined : json['idcontrat'],
        'statutContrat': !exists(json, 'statutContrat') ? undefined : json['statutContrat'],
        'concerne': !exists(json, 'concerne') ? undefined : json['concerne'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'codeContrat': !exists(json, 'codeContrat') ? undefined : json['codeContrat'],
        'metiers': !exists(json, 'metiers') ? undefined : json['metiers'],
        'nbJoursAre': !exists(json, 'nbJoursAre') ? undefined : json['nbJoursAre'],
        'idari': !exists(json, 'idari') ? undefined : json['idari'],
        'idpri': !exists(json, 'idpri') ? undefined : json['idpri'],
        'pri': !exists(json, 'pri') ? undefined : json['pri'],
        'dateDernierCct': !exists(json, 'dateDernierCct') ? undefined : (json['dateDernierCct'] === null ? null : new Date(json['dateDernierCct'])),
        'dateDernierCctScreening': !exists(json, 'dateDernierCctScreening') ? undefined : (json['dateDernierCctScreening'] === null ? null : new Date(json['dateDernierCctScreening'])),
        'centresA': !exists(json, 'centresA') ? undefined : json['centresA'],
        'centresBI': !exists(json, 'centresBI') ? undefined : json['centresBI'],
        'idservice': !exists(json, 'idservice') ? undefined : json['idservice'],
    };
}

export function DashboardCctDtoToJSON(value?: DashboardCctDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'idcontrat': value.idcontrat,
        'statutContrat': value.statutContrat,
        'concerne': value.concerne,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'codeContrat': value.codeContrat,
        'metiers': value.metiers,
        'nbJoursAre': value.nbJoursAre,
        'idari': value.idari,
        'idpri': value.idpri,
        'pri': value.pri,
        'dateDernierCct': value.dateDernierCct === undefined ? undefined : (value.dateDernierCct === null ? null : value.dateDernierCct.toISOString()),
        'dateDernierCctScreening': value.dateDernierCctScreening === undefined ? undefined : (value.dateDernierCctScreening === null ? null : value.dateDernierCctScreening.toISOString()),
        'centresA': value.centresA,
        'centresBI': value.centresBI,
        'idservice': value.idservice,
    };
}

